import { NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { ModalCloseResult } from './modal-close-result';

export class ModalContainerController {
  private ngbModalRef?: NgbModalRef;

  close(result?: ModalCloseResult): void {
    if (this.ngbModalRef) {
      this.ngbModalRef.close(result);
    } else {
      throw new Error('Trying to close a modal during initialization');
    }
  }

  dismiss(result?: ModalCloseResult): void {
    if (this.ngbModalRef) {
      this.ngbModalRef.dismiss(result);
    } else {
      throw new Error('Trying to dismiss a modal during initialization');
    }
  }

  setModalRef(ngbModalRef: NgbModalRef): void {
    this.ngbModalRef = ngbModalRef;
  }
}
